import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import BreakingNews from './components/BreakingNews';
import HeroCarousel from './components/HeroCarousel';
import NewsCards from './components/NewsCards';
import CarNewsTabs from './components/CarNewsTabs';
import DashboardTabs from './components/DashboardTabs';
import ComparisonSection from './components/ComparisonSection';
import ComparisonPage from './components/ComparisonPage';
import CarCategoryCarousel from './components/CarCategoryCarousel';
import { expectedCars, newlyLaunchedCars, popularCars } from './data/carCategoryData';
import Hatchback from './dropdown/Hatchback';
import News from './dropdown/News';
import Reviews from './dropdown/Reviews';
import EMICalculator from './dropdown/EMICalculator';
import InsuranceForm from './dropdown/InsuranceForm';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import AdBanner from './components/AdBanner';
import TopStories from './components/TopStories';
import JoinCommunity from './components/JoinCommunity';
import TermsAndConditions from './components/TermsAndConditions';

// NEW PAGE
import Gravite from './components/Gravite';
import Kodiaq from './components/Skoda';
import Pajero from './components/Pajero';
import Sorento from './components/Sorento';
import ZRV from './components/ZRV';
import City from './components/City';
import ModelY from './components/ModelY';

import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedComparison, setSelectedComparison] = useState(null);

  useEffect(() => {
    const path = window.location.pathname;

    let page = 'home';

    switch (path) {
      case '/comparison':
        page = 'comparison';
        break;

      case '/joincommunity':
        page = 'joincommunity';
        break;

      case '/hatchback':
        page = 'hatchback';
        break;

      case '/emi':
        page = 'emi';
        break;

      case '/insurance':
        page = 'insurance';
        break;

      case '/news':
        page = 'news';
        break;

      case '/reviews':
        page = 'reviews';
        break;

      case '/privacy':
        page = 'privacy';
        break;

      case '/terms&conditions':
        page = 'terms&conditions';
        break;

      case '/best-offers/gravite':
        page = 'gravite';
        break;

      case '/best-offers/kodiaq':
        page = 'kodiaq';
        break;
        
      case "/best-offers/pajero":
      page = "pajero";
      break;

      case "/best-offers/sorento":
      page = "sorento";
      break;

      case "/best-offers/zrv":
      page = "zrv";
      break;

      case "/best-offers/city":
      page = "city";
      break;

      case "/best-offers/modely":
      page = "modely";
      break;

      default:
      page = 'home';
    }

    setCurrentPage(page);

    window.history.replaceState({ page }, '', path);

    const handlePopState = (event) => {
      if (event.state?.page) {
        setCurrentPage(event.state.page);
      } else {
        setCurrentPage('home');
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const handleNavigate = (page) => {
    const routes = {
      home: '/',
      comparison: '/comparison',
      joincommunity: '/joincommunity',
      hatchback: '/hatchback',
      emi: '/emi',
      insurance: '/insurance',
      news: '/news',
      reviews: '/reviews',
      privacy: '/privacy',
      'terms&conditions': '/terms&conditions',
      gravite: '/best-offers/gravite',
      kodiaq: '/best-offers/kodiaq',
      pajero: "/best-offers/pajero",
      sorento: "/best-offers/sorento",
      zrv: "/best-offers/zrv",
      city: "/best-offers/city",
      modely: "/best-offers/modely",
    };

    window.history.pushState(
      { page },
      '',
      routes[page] || '/'
    );

    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const handleComparisonNavigate = (car1, car2) => {
    setSelectedComparison({ car1, car2 });

    window.history.pushState(
      { page: 'comparison' },
      '',
      '/comparison'
    );

    setCurrentPage('comparison');
    window.scrollTo(0, 0);
  };

  return (
    <div className="App">
      <Navbar onNavigate={handleNavigate} />

      {currentPage === 'home' && (
        <>
          <BreakingNews />
          <HeroCarousel />
          <TopStories onNavigate={handleNavigate} />

          {/* Pass navigation to AdBanner */}
          <AdBanner onNavigate={handleNavigate} />

          <NewsCards />
          <CarNewsTabs />
          <DashboardTabs />

          <ComparisonSection
            onCompare={handleComparisonNavigate}
          />

          <CarCategoryCarousel
            expectedCars={expectedCars}
            newlyLaunchedCars={newlyLaunchedCars}
            popularCars={popularCars}
          />

          <FAQ />
        </>
      )}

      {currentPage === 'comparison' && (
        <ComparisonPage
          comparison={selectedComparison}
          onBack={() => handleNavigate('home')}
        />
      )}

      {currentPage === 'joincommunity' && <JoinCommunity />}
      {currentPage === 'hatchback' && <Hatchback />}
      {currentPage === 'emi' && <EMICalculator />}
      {currentPage === 'insurance' && <InsuranceForm />}
      {currentPage === 'news' && <News />}
      {currentPage === 'reviews' && <Reviews />}
      {currentPage === 'privacy' && <PrivacyPolicy />}
      {currentPage === 'terms&conditions' && <TermsAndConditions />}

      {/* NEW PAGE */}
      {currentPage === 'gravite' && <Gravite />}
      {currentPage === 'kodiaq' && <Kodiaq />}
      {currentPage === "pajero" && <Pajero />}
{currentPage === "sorento" && <Sorento />}
{currentPage === "zrv" && <ZRV />}
{currentPage === "city" && <City />}
{currentPage === "modely" && <ModelY />}
      <Footer onNavigate={handleNavigate} />
    </div>
  );
}

export default App;